import React from "react";
import { Alert, type AlertColor } from "@mui/material";
import { closeSnackbar, type SnackbarKey, type SnackbarMessage } from "notistack";

interface BaseSnackbarProps {
  key: SnackbarKey;
  message: SnackbarMessage;
  severity?: AlertColor;
}

// 👇 반드시 forwardRef 사용
const BaseSnackbar = React.forwardRef<HTMLDivElement, BaseSnackbarProps>(
  ({ message, severity = "info", key }, ref) => {
    return (
      <Alert
        ref={ref}
        variant="filled"
        severity={severity}
        onClose={() => closeSnackbar(key)}
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    );
  }
);

BaseSnackbar.displayName = "BaseSnackbar";
export default BaseSnackbar;
